<script setup lang="ts">
  import type { RouteLocationRaw } from 'vue-router'
  import { fmt } from '@/functions'

  defineProps<{
    active?: boolean,
    to?: RouteLocationRaw,
    count?: number,
  }>()
</script>

<template>
  <component
    :is="to ? 'router-link' : 'button'"
    class="whitespace-nowrap border-b-2 p-2"
    :class="{ active: active, inactive: active === false }"
    :to="to">
    <slot></slot>
    <template v-if="count !== undefined">
      ({{ fmt.number(count) }})
    </template>
  </component>
</template>

<style lang="postcss" scoped>
  .active {
    @apply border-primary-500 text-primary-500;
  }
  .inactive {
    @apply text-gray-400 hover:border-gray-400 hover:text-gray-600;
  }
</style>
